import PropTypes from 'prop-types';

import Alert from '#globalComponents/Alert/Alert';
import Button from '#globalComponents/Button/Button';
import Checkbox from '#globalComponents/Checkbox/Checkbox';
import { getErrorMessage } from '#lib/errors/errorMessages';

const RemoveConfirmation = ({
	member,
	transferDataOnRemove,
	onTransferDataToggle,
	onToggleRemove,
	onRemove,
	removeMutation,
}) => {
	const displayName = member.fullName || member.email;

	return (
		<Alert tone="warning" title={`${displayName} wirklich entfernen?`} className="mt-3">
			<p>Der Nutzer wird vollständig gelöscht und kann sich nicht mehr einloggen.</p>
			<div className="mt-3 text-text">
				<Checkbox
					id={`remove-transfer-${member.userId}`}
					checked={transferDataOnRemove}
					onChange={onTransferDataToggle}
					label="Alle Suchergebnisse des Nutzers auf den Organisations-Admin übertragen"
				/>
			</div>
			{removeMutation.isError && <p className="mt-2 text-xs">{getErrorMessage(removeMutation.error)}</p>}
			<div className="mt-3 flex justify-end gap-2">
				<Button variant="outline" size="sm" onClick={() => onToggleRemove(null)}>
					Abbrechen
				</Button>
				<Button
					variant="danger"
					size="sm"
					onClick={() => onRemove(member.userId)}
					loading={removeMutation.isPending}
				>
					Entfernen
				</Button>
			</div>
		</Alert>
	);
};

RemoveConfirmation.propTypes = {
	member: PropTypes.object.isRequired,
	transferDataOnRemove: PropTypes.bool.isRequired,
	onTransferDataToggle: PropTypes.func.isRequired,
	onToggleRemove: PropTypes.func.isRequired,
	onRemove: PropTypes.func.isRequired,
	removeMutation: PropTypes.object.isRequired,
};

export default RemoveConfirmation;
